module.exports = __webpack_public_path__ + "media/bgm-wish.a0840f18.mp3";